<medrecord-ui-action-icon class="mr-2" [tooltip]="tooltip | translate" (clicked)="goBack()" actionType="generic"
  ><medrecord-svg-arrow-left icon width="18"></medrecord-svg-arrow-left
></medrecord-ui-action-icon>
